/* Creator offer chips: canonical campaign facts + shared conditional wording. Approved product
 * pictures, links and actions are untouched. No private selector or wall-clock campaign truth. */
(function (W, D) {
  'use strict';
  if (W.IoWornOffer) return;
  var CDN = 'https://interactopus-cdn.pop-cristian-bogdan.workers.dev/stores/', DAY = 864e5;
  var str = function (x) { return typeof x === 'string' ? x : x == null ? '' : String(x); };
  function pct(bps, lang) {
    var n = Number(bps) / 100;
    if (!(n > 0) || n >= 100) return '';
    try { return new Intl.NumberFormat(lang || undefined, { style: 'percent', maximumFractionDigits: 1 }).format(n / 100); } catch (e) { return n + '%'; }
  }
  function today(now) { return new Date(now).toISOString().slice(0, 10); }
  function addDays(day, n) { return new Date(Date.parse(day + 'T00:00:00Z') + n * DAY).toISOString().slice(0, 10); }
  function setChip(pid, now, plan, words, lang) {
    if (!plan || !Array.isArray(plan.offers) || !Array.isArray(plan.sets) || !words.set) return null;
    var o = null;
    for (var i = 0; i < plan.offers.length; i++) if (plan.offers[i] && plan.offers[i].type === 'set_saving') { o = plan.offers[i]; break; }
    if (!o || o.enforced !== true) return null;
    var aud = o.audience || plan.audience || 'everyone';
    if (aud !== 'everyone') return null;
    var d = today(now);
    if (o.valid_from && d < addDays(str(o.valid_from), 1)) return null;
    if (o.valid_to && d >= addDays(str(o.valid_to), 0)) return null;
    var inSet = plan.sets.some(function (s) { return s && Array.isArray(s.products) && s.products.map(str).indexOf(pid) > -1; });
    if (!inSet) return null;
    var ts = (o.reward && Array.isArray(o.reward.tiers) ? o.reward.tiers : []).filter(function (t) { return t && Number(t.pieces) >= 2 && Number(t.bps) > 0; })
      .sort(function (a, b) { return a.pieces - b.pieces; });
    var p = ts.length ? pct(ts[0].bps, lang) : '';
    if (!p) return null;
    return { kind: 'set', text: words.set.replace('[pct]', p).replace('[count]', String(ts[0].pieces)) };
  }
  function wordsOf(root) {
    var ok = function (t) { t = str(t); return t && !/translation missing/i.test(t) ? t : ''; };
    var w = { set: ok(root.getAttribute('data-chip-set')), campaign: ok(root.getAttribute('data-chip-campaign')) };
    if (w.set && (w.set.indexOf('[pct]') < 0 || w.set.indexOf('[count]') < 0)) w.set = '';
    if (w.campaign && (w.campaign.indexOf('[label]') < 0 || w.campaign.indexOf('[count]') < 0)) w.campaign = '';
    return w;
  }
  function chipFor(pid, context, plan, words, lang) {
    if (!words || !context || context.status !== 'ready' || !context.clock || context.clock.trusted !== true || !Number.isSafeInteger(context.clock.now) || context.clock.now <= 0 || !W.InteractopusCampaignWords || !/^[1-9][0-9]{0,19}$/.test(str(pid))) return null;
    var input = {fact: context.fact, cartPackage: context.cartPackage, productIds: [str(pid)], lang: lang, currency: context.currency};
    var terms = W.InteractopusCampaignWords.terms(input), text = W.InteractopusCampaignWords.factMessage(input);
    if (text) return {kind: 'campaign', text: text};
    return terms.noCampaign && plan && plan.pkg === context.version && plan.shop_domain === str(W.Shopify && W.Shopify.shop) && context.clock && context.clock.trusted === true ? setChip(str(pid), context.clock.now, plan, words, lang) : null;
  }
  /* Actual recommended cards own attention; the organic creator photo never does.
     Tags always show (founder 2026-10-27): a piece's row and photo pin stay visible after the shopper has seen it,
     while another box holds it, and after it went into the bag (the row keeps its "In your bag" state). Only a piece the
     shopper dismissed hides its tag. `allowed` now means only "this tag records exposure and holds a reservation": a
     tag shown because it is seen, reserved elsewhere or bagged records nothing and reserves nothing, so the memory's
     repetition rules for every other box are unchanged. */
  function recommendationCards() {
    var states = new Map(), serial = 0;
    function memory() { var a = W.InteractopusOffers, m = a && a.recommendation; return m && m.ready && m.ready() && ['check','reserve','releaseReservation','mount','end'].every(function (k) { return typeof m[k] === 'function'; }) ? m : null; }
    function bagged(id) {
      var c = W.InteractopusCart, bag = c && c.cart && c.cart();
      var ids = bag && Array.isArray(bag.items) ? bag.items.map(function (x) { return str(x.product_id); }) : W.InteractopusCartProductIds;
      return Array.isArray(ids) && ids.indexOf(id) !== -1;
    }
    function actual(root) {
      return [].map.call(root.querySelectorAll('[data-io-item]'), function (el) {
        var chip = el.querySelector('[data-io-chip-for]'), id = chip && str(chip.getAttribute('data-io-chip-for'));
        var key = el.getAttribute('data-io-k');
        var pins = key ? [].filter.call(root.querySelectorAll('[data-io-pin][data-io-k]'), function (pin) { return pin.getAttribute('data-io-k') === key; }) : [];
        return id && /^[1-9][0-9]{0,19}$/.test(id) ? {element: el, id: id, pins: pins} : null;
      }).filter(Boolean).slice(0, 16);
    }
    function hide(c) {
      if (!c.saved) c.saved = {hidden: c.element.hidden, display: c.element.style.getPropertyValue('display'), priority: c.element.style.getPropertyPriority('display')};
      c.element.hidden = true; c.element.style.setProperty('display', 'none', 'important');
      c.element.setAttribute('data-io-recommendation-hidden', '');
      if (!c.pinSaved) c.pinSaved = c.pins.map(function (pin) { return {element: pin, hidden: pin.hidden, display: pin.style.getPropertyValue('display'), priority: pin.style.getPropertyPriority('display')}; });
      c.pinSaved.forEach(function (p) { p.element.hidden = true; p.element.style.setProperty('display', 'none', 'important'); });
    }
    function restore(c) {
      if (!c.saved) return;
      c.element.hidden = c.saved.hidden;
      if (c.saved.display) c.element.style.setProperty('display', c.saved.display, c.saved.priority); else c.element.style.removeProperty('display');
      c.element.removeAttribute('data-io-recommendation-hidden'); c.saved = null;
      (c.pinSaved || []).forEach(function (p) { p.element.hidden = p.hidden; if (p.display) p.element.style.setProperty('display', p.display, p.priority); else p.element.style.removeProperty('display'); }); c.pinSaved = null;
    }
    function release(root) {
      var s = states.get(root); if (!s) return;
      s.active = false;
      s.cards.forEach(function (c) { if (c.stop) c.stop(); s.memory.end(c.key); restore(c); });
      s.memory.releaseReservation(s.id); states.delete(root);
    }
    function update(s) {
      // A dismissal hides the tag; an addition only stops its exposure recording (the tag and its in-bag state stay).
      s.cards.forEach(function (c) {
        if (c.saved) return;
        var answer = s.memory.check({productIds: [c.id]}, 'page', c.key, s.id), gone = !!answer && answer.reason === 'dismissed';
        if (c.allowed && (gone || bagged(c.id))) { c.allowed = false; if (c.stop) c.stop(); s.memory.end(c.key); }
        if (gone) hide(c);
      });
    }
    function prepare(root) {
      var m = memory(); if (!m || !root || root.isConnected === false) return null;
      var found = actual(root), s = states.get(root);
      if (s && (s.memory !== m || s.cards.length !== found.length || s.cards.some(function (c, i) { return c.id !== found[i].id || c.element !== found[i].element; }))) { release(root); s = null; }
      if (s) { update(s); return s; }
      if (!found.length || states.size >= 96) return null;
      s = {root: root, memory: m, id: 'creator:' + (++serial), active: true, mounted: false, cards: found};
      found.forEach(function (c, i) {
        c.key = s.id + ':' + i;
        var answer = m.check({productIds: [c.id]}, 'page', c.key, s.id);
        c.allowed = !!answer && answer.kind !== 'suppress' && !bagged(c.id);
        c.dismissed = !!answer && answer.reason === 'dismissed';
      });
      var ids = found.filter(function (c) { return c.allowed; }).map(function (c) { return c.id; });
      if (ids.length && !m.reserve({productIds: ids}, s.id, function () { return s.active && root.isConnected !== false; })) found.forEach(function (c) { c.allowed = false; });
      found.forEach(function (c) { if (c.dismissed) hide(c); });
      states.set(root, s); return s;
    }
    function mount(root) {
      var s = prepare(root); if (!s) return null;
      s.mounted = true;
      s.cards.forEach(function (c) {
        if (!c.allowed) return;
        c.stop = s.memory.mount({element: c.element, identity: {productIds: [c.id]}, surface: 'page', presentationId: c.key, reservationId: s.id,
          isActive: function () { return s.active && s.mounted && c.allowed && root.isConnected !== false && root.contains(c.element) && !c.element.hidden; }});
      });
      return s;
    }
    function sync(root) {
      states.forEach(function (s, r) { if (r.isConnected === false) release(r); });
      var s = states.get(root);
      if (root.closest && root.closest('[data-io-composition-photo]') && !(s && s.mounted)) return null;
      return mount(root);
    }
    return Object.freeze({prepare: prepare, mount: mount, release: release, sync: sync});
  }

  var recommendations = recommendationCards();
  var loading = null, roots = [], observer = null, cartBound = null;
  function ensure() {
    var P = W.InteractopusPackage;
    if (!P || typeof P.asset !== 'function' || typeof P.load !== 'function') return Promise.resolve(false);
    if (!loading) loading = Promise.all([
      W.InteractopusCampaignContext ? null : P.load(P.asset('io-campaign-context.min.js')),
      W.InteractopusCampaignWords ? null : P.load(P.asset('io-campaign-words.min.js'))
    ]).then(function () { var ready = !!(W.InteractopusCampaignContext && W.InteractopusCampaignWords); if (!ready) loading = null; return ready; }).catch(function () { loading = null; return false; });
    return loading;
  }
  function clear(root) {
    [].forEach.call(root.querySelectorAll('[data-io-chip-for]'), function (el) { el.hidden = true; el.textContent = ''; el.removeAttribute('data-kind'); });
  }
  function near(root) {
    if (root.isConnected === false || D.hidden || !root.getBoundingClientRect) return false;
    var r = root.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom >= -800 && r.top < (W.innerHeight || 800) + 800;
  }
  function later(root, delay) {
    var s = root.__ioCampaignChip;
    if (!s) return;
    W.clearTimeout(s.timer);
    if (s.near && near(root)) s.timer = W.setTimeout(function () { paint(root); }, Math.max(1, delay));
  }
  function bindCart() {
    var cart = W.InteractopusCart;
    if (cart && cart !== cartBound && typeof cart.on === 'function') { cartBound = cart; cart.on('cart', refresh); }
    return cart;
  }
  function read() {
    var cart = bindCart();
    return Promise.resolve().then(function () { return cart && typeof cart.snapshot === 'function' ? cart.snapshot() : null; })
      .then(function () { return W.InteractopusCampaignContext.read({shop: str(W.Shopify && W.Shopify.shop)}); });
  }
  function refreshDelay(context) {
    var delay = 30000, c;
    try { c = W.InteractopusCart.clock(); } catch (_) { return 1000; }
    if (!c || c.trusted !== true || !Number.isFinite(c.ageMs) || c.ageMs < 0 || c.ageMs > 300000) return 1000;
    delay = Math.min(delay, Math.max(1, 300000 - c.ageMs));
    // Invalidation only: wake before any published switch's canonical two-minute quiet boundary.
    // Running-campaign choice remains exclusively in the canonical facade.
    var list = context.cartPackage && context.cartPackage.cart_campaigns && context.cartPackage.cart_campaigns.list;
    (Array.isArray(list) ? list : []).forEach(function (entry) {
      ['starts_at', 'ends_at'].forEach(function (key) { var wait = Date.parse(entry[key]) - c.now - 120000; if (wait > 0) delay = Math.min(delay, wait); });
    });
    return delay;
  }
  function paint(root) {
    bindCart();
    var s = root.__ioCampaignChip;
    if (!s) return Promise.resolve();
    recommendations.sync(root);
    var seq = ++s.seq; W.clearTimeout(s.timer); clear(root);
    if (!s.near || !near(root)) return Promise.resolve();
    function current() { return root.__ioCampaignChip === s && s.seq === seq && s.near && near(root); }
    return ensure().then(function (ready) { return ready && current() ? read() : null; }).then(function (context) {
      if (!current() || !context || context.status !== 'ready') { if (current()) later(root, 30000); return; }
      var lang = str(W.Shopify && W.Shopify.locale).toLowerCase(), chips = root.querySelectorAll('[data-io-chip-for]');
      var neutral = [].some.call(chips, function (el) { return W.InteractopusCampaignWords.terms({fact: context.fact, cartPackage: context.cartPackage, productIds: [str(el.getAttribute('data-io-chip-for'))], lang: lang, currency: context.currency}).noCampaign; });
      var P = W.InteractopusPackage;
      var plan = neutral ? P.current(str(W.Shopify && W.Shopify.shop)).then(function (p) {
        if (!p || p.version !== context.version || !p.surfaces || p.surfaces.offers !== true) return null;
        return P.get(CDN + p.shop_domain + '/v/' + context.version + '/offer-plan.json', 65536).then(function (r) { return r && r.status === 'ok' && r.json && r.json.v === 1 && r.json.pkg === context.version && r.json.shop_domain === str(W.Shopify && W.Shopify.shop) ? r.json : null; });
      }) : Promise.resolve(null);
      return plan.then(function (offerPlan) { return read().then(function (latest) {
        if (!current() || !latest || latest.status !== 'ready' || latest.version !== context.version || latest.currency !== context.currency) { if (current()) later(root, 30000); return; }
        var words = wordsOf(root);
        [].forEach.call(root.querySelectorAll('[data-io-chip-for]'), function (el) {
          var c = chipFor(el.getAttribute('data-io-chip-for'), latest, offerPlan, words, str(W.Shopify && W.Shopify.locale).toLowerCase());
          if (c) { el.textContent = c.text; el.setAttribute('data-kind', c.kind); el.hidden = false; }
        });
        later(root, refreshDelay(latest));
      }); });
    }).catch(function () { if (current()) { clear(root); later(root, 30000); } });
  }
  function start() {
    bindCart();
    [].forEach.call(D.querySelectorAll('[data-io-look][data-chip-set]'), function (root) {
      if (root.__ioCampaignChip) { if (root.__ioCampaignChip.near) paint(root); return; }
      recommendations.sync(root);
      var s = root.__ioCampaignChip = {near: false, seq: 0, timer: 0}; roots.push(root);
      if (W.MutationObserver) { s.mutation = new W.MutationObserver(function () { paint(root); }); s.mutation.observe(root, {subtree: true, attributes: true, attributeFilter: ['data-io-chip-for']}); }
      if (W.IntersectionObserver) {
        if (!observer) observer = new W.IntersectionObserver(function (entries) { entries.forEach(function (e) { var state = e.target.__ioCampaignChip; if (state) { state.near = e.isIntersecting; paint(e.target); } }); }, {rootMargin: '800px 0px'});
        observer.observe(root);
      } else { s.near = near(root); if (s.near) paint(root); }
    });
  }
  function refresh() { bindCart(); roots.slice().forEach(function (root) { recommendations.sync(root); var s = root.__ioCampaignChip; if (!s) return; if (!W.IntersectionObserver) s.near = near(root); if (s.near) paint(root); }); }
  W.IoWornOffer = Object.freeze({chipFor: chipFor, words: wordsOf, paint: paint, recommendations: recommendations});
  D.dispatchEvent(new CustomEvent('interactopus:creator-cards-ready'));
  D.addEventListener('shopify:section:load', start);
  D.addEventListener('interactopus:cart-ready', refresh);
  D.addEventListener('interactopus:offers:ready', function () { roots.forEach(function (root) { recommendations.sync(root); }); });
  D.addEventListener('interactopus:catalog-committed', function () { roots.forEach(function (root) { recommendations.sync(root); }); });
  D.addEventListener('visibilitychange', function () { if (D.hidden) roots.forEach(function (root) { var s = root.__ioCampaignChip; if (s) { s.seq++; W.clearTimeout(s.timer); clear(root); } }); else refresh(); });
  D.addEventListener('shopify:section:unload', function (event) { roots = roots.filter(function (root) { if (event.target === root || event.target && event.target.contains && event.target.contains(root)) { var s = root.__ioCampaignChip; if (s) { s.seq++; W.clearTimeout(s.timer); if (s.mutation) s.mutation.disconnect(); } if (observer) observer.unobserve(root); recommendations.release(root); delete root.__ioCampaignChip; clear(root); return false; } return true; }); });
  W.addEventListener('scroll', function () { if (!W.IntersectionObserver) refresh(); }, {passive: true}); W.addEventListener('resize', refresh);
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
}(window, document));
